module.exports = "../images/boat-2.jpg?v=48440db";